export interface VolunteerFormType {
  username: string;
  salutation: string | null;
  title: string | null;
  lastName: string;
  firstName: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  country: string;
  email: string;
  phone: string | null;
  remarks: string | null;
}

export const VolunteerMaxLength = {
  username: 50,
  salutation: 50,
  title: 50,
  lastName: 50,
  firstName: 50,
  email: 254,
  phone: 50,
};

/**
 * Kürzel lower bound, mirroring the backend's `Volunteer.UsernameMinLength`. Dictated by Keycloak:
 * the Kürzel becomes the volunteer's Keycloak username, and the realm's user profile rejects
 * usernames shorter than three characters.
 */
export const VolunteerMinLength = {
  username: 3,
};

/**
 * Character set the Kürzel is restricted to, mirroring the backend's `Volunteer.UsernamePattern`.
 * Narrower than Keycloak's own username rules on purpose — ASCII only, so it also clears
 * Keycloak's IDN-homograph check.
 */
export const UsernamePattern = /^[a-zA-Z0-9._-]+$/;
